/**
 * Truncar a pré-visualização de um post a uma linha.
 *
 * O `display: -webkit-box` é mapeado pelo Firefox para a caixa legada `-moz-box`, cuja
 * largura mínima intrínseca é o max-content dos filhos, ou seja, o texto todo numa linha
 * só. Como as células do dia do calendário são dimensionadas em percentagem, essa largura
 * propaga pelos flex items acima e estica o calendário inteiro (DEV-4475). Daí o
 * `minWidth: 0` e as oportunidades de quebra.
 *
 * Passar sempre só texto como filho, nunca elementos: com um elemento lá dentro (era o
 * caso dos rascunhos só com briefing, que levavam o ícone da lâmpada) o Gecko volta a
 * usar a linha completa como largura mínima. Ícones ficam fora, ao lado.
 */
export const clampOneLine = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
    minWidth: 0,
    lineBreak: 'anywhere',
    overflowWrap: 'anywhere',
} as const;
